module.exports = __webpack_public_path__ + "static/media/darshan_shah.36d84ac3.jpg";